'use client';

import Image from "next/image";
import Link from "next/link";
import { useParams } from "next/navigation";

type CardsSectionProps = {
  cards: Array<{
    title: string;
    description: string;
    image?: string;
    action?: string;
    link?: string;
  }>;
};

export function CardsSection({ cards }: CardsSectionProps) {
  const params = useParams();
  const lang = params.lang as string;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
      {cards.map((card, i) => (
        <div
          key={i}
          className="flex flex-col rounded-2xl border border-gray-200 shadow-sm overflow-hidden bg-white"
        >
          <div className="w-full h-48 bg-gray-100 flex items-center justify-center">
            {card.image ? (
              <Image
                src={card.image}
                alt={card.title}
                width={400}
                height={200}
                className="object-cover w-full h-full"
              />
            ) : (
              <span className="text-gray-400 text-sm">No image</span>
            )}
          </div>
          <div className="flex flex-col gap-3 p-6 flex-1">
            <h5 className="text-lg font-semibold text-gray-800">{card.title}</h5>
            <p className="text-gray-600 text-[18px] leading-relaxed">
              {card.description}
            </p>
          </div>
          {card.action && (
            <div className="p-6 pt-0">
              {card.link ? (
                <Link href={`/${lang}/services/financing/${card.link}`}>
                  <button
                    className="w-fit bg-primary-700 text-white font-medium px-4 py-2 rounded-md hover:bg-primary-800 transition-colors"
                  >
                    {card.action}
                  </button>
                </Link>
              ) : (
                <button
                  className="w-fit bg-primary-700 text-white font-medium px-4 py-2 rounded-md hover:bg-primary-800 transition-colors"
                >
                  {card.action}
                </button>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
